<div class="login-inside-container" id="div_login-inside-container_af359166">
  <form [formGroup]="frmLogin" id="form_41f2a9ee">
    <!-- Company Name Input -->
    <span class="p-float-label" id="span_p-float-label_14dd85c8">
      <input
        id="company_name"
        type="text"
        pInputText=""
        formControlName="company_name"
        required=""
      />
      <label for="company_name" id="label_5135f489">Company Name</label>
    </span>
    <small
      class="p-error block"
      *ngIf="
        frmLogin.get('company_name')?.errors?.['required'] &&
        frmLogin.get('company_name')?.touched
      "
      aria-label="Company Name is required"
      title="Company Name is required"
      id="small_p-error_4a7116e9"
      >company name is required.</small
    >

    <!-- First Name Input -->
    <span class="p-float-label" id="span_p-float-label_361cfd91">
      <input
        id="first_name"
        type="text"
        pInputText=""
        formControlName="first_name"
        required=""
      />
      <label for="first_name" id="label_2df4d1ff">First Name</label>
    </span>
    <small
      class="p-error block"
      *ngIf="
        frmLogin.get('first_name')?.errors?.['required'] &&
        frmLogin.get('first_name')?.touched
      "
      aria-label="First Name is required"
      title="First Name is required"
      id="small_p-error_d345c45b"
      >first name is required.</small
    >
    <small
      class="p-error block"
      *ngIf="
        frmLogin.get('first_name')?.errors?.['pattern'] &&
        frmLogin.get('first_name')?.touched
      "
      aria-label="Invalid First Name format"
      title="Invalid First Name format"
      id="small_p-error_0882caf1"
      >first name must contain only letters, spaces, and hyphens.</small
    >

    <!-- Last Name Input -->
    <span class="p-float-label" id="span_p-float-label_82676dc4">
      <input
        id="last_name"
        type="text"
        pInputText=""
        formControlName="last_name"
        required=""
      />
      <label for="last_name" id="label_219591be">Last Name</label>
    </span>
    <small
      class="p-error block"
      *ngIf="
        frmLogin.get('last_name')?.errors?.['required'] &&
        frmLogin.get('last_name')?.touched
      "
      aria-label="Last Name is required"
      title="Last Name is required"
      id="small_p-error_1a79540d"
      >last name is required.</small
    >
    <small
      class="p-error block"
      *ngIf="
        frmLogin.get('last_name')?.errors?.['pattern'] &&
        frmLogin.get('last_name')?.touched
      "
      aria-label="Invalid Last Name format"
      title="Invalid Last Name format"
      id="small_p-error_1fd4ce3e"
      >last name must contain only letters, spaces, and hyphens.</small
    >

    <!-- Email Input -->
    <span class="p-float-label" id="span_p-float-label_95099423">
      <input
        id="email"
        type="email"
        pInputText=""
        formControlName="email"
        required=""
      />
      <label for="email" id="label_5ebc38c1">Email</label>
    </span>
    <small
      class="p-error block"
      *ngIf="
        frmLogin.get('email')?.errors?.['required'] &&
        frmLogin.get('email')?.touched
      "
      aria-label="Email is required"
      title="Email is required"
      id="small_p-error_8a0621ab"
      >email is required.</small
    >

    <!-- Contact Number Input -->
    <span
      class="p-float-label"
      style="display: inline-block"
      id="span_p-float-label_77f6bfe4"
    >
      <div class="phone-group" id="div_phone-group_18a8224a">
        <p-dropdown
          [options]="CountryCodeOptions"
          ngDefaultControl=""
          class="phone"
          name="country_code"
          formControlName="country_code"
          [ngClass]="{ 'phone-filled': validatePhone() }"
          optionValue="value"
          optionLabel="label"
          id="p-dropdown_phone_2daa30c5"
        >
          <ng-template let-item="" pTemplate="item" id="ng-template_e024c96e">
            <div id="div_c32f8369">{{ item.label }}</div>
          </ng-template>
        </p-dropdown>
        <input
          id="contact_number"
          type="text"
          pInputText=""
          name="phone_no"
          style="width: 100%; margin-bottom: 4%; margin-left: 3%"
          [OnlyNumber]="true"
          [minlength]="10"
          formControlName="phone_no"
          [ngClass]="{
            filled:
              frmLogin.value['phone_no'] !== '' &&
              (validatePhone() || frmLogin.get('phone_no')?.pristine)
          }"
          required=""
        />
        <label
          class="label-select"
          style="top: 10px !important; margin-left: -4%"
          *ngIf="
            frmLogin.value['country_code'] !== '' ||
            frmLogin.value['phone_no'] !== ''
          "
          id="label_label-select_3b074bce"
          >Contact Number</label
        >
      </div>
    </span>
    <small
      class="p-error block"
      *ngIf="
        frmLogin.get('phone_no')?.touched &&
        frmLogin.get('phone_no')?.errors?.['required']
      "
      aria-label="Phone number is required"
      title="Phone number is required"
      id="small_p-error_c15e5391"
      >phone number is required.</small
    >
    <small
      class="p-error block"
      *ngIf="
        (frmLogin.get('phone_no')?.hasError('minlength') || !validatePhone()) &&
        frmLogin.get('phone_no')?.touched
      "
      aria-label="Phone number should be 10 digits long"
      title="Phone number should be 10 digits long"
      id="small_p-error_2c0eabde"
      >phone number should be 10 digits long.</small
    >

    <!-- Submit Button -->
    <div class="btn-panel" id="div_btn-panel_45c2ea27">
      <button
        class="next-button"
        (click)="signUp()"
        [disabled]="!frmLogin.valid"
        id="button_next-button_a1b24ebc"
      >
        SUBMIT
      </button>
    </div>
  </form>

  <!-- Loading Spinner -->
  <div
    class="progress-spinner"
    *ngIf="loading"
    id="div_progress-spinner_74abb6de"
  >
    <p-progressSpinner
      styleClass="custom-spinner"
      id="p-progressSpinner_4b694f90"
    ></p-progressSpinner>
  </div>
</div>
